export { default as LoyaltyTimCard } from './tim-card';
